export const AlternativePaymentMethod = {
  FLYWIRE: "FLYWIRE",
};
